import { InjectionToken } from '@angular/core';

/**
 * Provides an injection token for overriding the generated API base path.
 */
export const BASE_PATH = new InjectionToken<string>('basePath');
export const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}


